module.exports = __webpack_public_path__ + "img/operationCapacity8.e20788ef.png";